export default (function (_ref) {
  var request = _ref.request;
  return {
    smartControlAdd: function smartControlAdd(data) {
      return request({
        url: '/iot/smartControl/add',
        method: 'post',
        data: data
      });
    },
    smartControlModify: function smartControlModify(data) {
      return request({
        url: "/iot/smartControl/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    smartControlDel: function smartControlDel(id) {
      return request({
        url: "/iot/smartControl/".concat(id, "/del"),
        method: 'delete'
      });
    },
    smartControlQuery: function smartControlQuery(data) {
      return request({
        url: '/iot/smartControl/query',
        method: 'get',
        params: data
      });
    },
    smartControlDetail: function smartControlDetail(id) {
      return request({
        url: "/iot/smartControl/".concat(id, "/detail"),
        method: 'get'
      });
    },
    smartControlCache: function smartControlCache(controlId) {
      return request({
        url: "/iot/smartControl/cache/".concat(controlId),
        method: 'get'
      });
    },
    smartControlCacheClear: function smartControlCacheClear(params) {
      return request({
        url: "/iot/smartControl/cache/clear",
        method: 'DELETE',
        params: params
      });
    }
  };
});